/** Versiones ordenadas de la más nueva a la más vieja (v1.10 va después de v1.9). */
export function byVersionDesc<T extends { version: string }>(list: T[]): T[] {
  const key = (v: string) => (/^v(\d+)\.(\d+)$/.exec(v) ?? [, '0', '0']).slice(1).map(Number) as [number, number];
  return [...list].sort((a, b) => {
    const [x1, y1] = key(a.version);
    const [x2, y2] = key(b.version);
    return x2 - x1 || y2 - y1;
  });
}

/** Nombres pegados de una lista: uno por línea, sin vacíos ni repetidos. */
export function parseNames(text: string): string[] {
  const seen = new Set<string>();
  return text.split(/\r?\n/).map((l) => l.trim().replace(/\s+/g, ' ')).filter((l) => l && !seen.has(l.toLowerCase()) && seen.add(l.toLowerCase()));
}
